<template>
  <div class="CognateSearch">
    <div class="i-theme-color p-2 rounded-1">
      <h1 class="mx-2">Cognate Candidates</h1>
      <div class="m-2">
        <input ref="searchInput" v-model="searchString" v-on:keyup.enter="onEnter" />
        <span>
          <button @click="onCharButtonClicked">ʔ</button>
          <button @click="onCharButtonClicked">ḥ</button>
          <button @click="onCharButtonClicked">ṭ</button>
          <button @click="onCharButtonClicked">ʕ</button>
          <button @click="onCharButtonClicked">ṣ</button>
          <button @click="onCharButtonClicked">š</button>
        </span>
        <span>
          <input id="reflexTunerToggle" class="mx-1" type="checkbox" @change="onReflexTunerToggleChange" />
          <label for="reflexTunerToggle">Show reflex table</label>
        </span>
        <ReflexTuner ref="reflexTuner"  v-show="!reflexTunerHidden" @reflexChanged="onChange" class="mt-2" />
      </div>
    </div>
    <div class="p-2 text-center" v-if="loading">Loading...</div>
    <div class="row p-2" v-if="!loading">
      <div class="col-sm">
        <h2>Akkadian <small>(eBL Dictionary)</small></h2>
        <ol class="scroll-overflow" style="max-height: 55vh;">
          <li v-for="cognate in data.Akkadian" :key="cognate.entry">
            <a :href="cognate.url" target="_blank">{{ cognate.entry }}</a>
          </li>
        </ol>
      </div>
      <div class="col-sm scroll-overflow" style="max-height: 60vh;">
        <h2>Aramaic <small>(CAL)</small></h2>
        <ol class="scroll-overflow" style="max-height: 55vh;">
          <li v-for="cognate in data.Aramaic" :key="cognate.entry">
            <a :href="cognate.url" target="_blank">{{ cognate.entry }}</a>
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import ReflexTuner from './ReflexTuner.vue';

export default {
  name: 'CognateSearch',
  props: {
     backendURL: String,
  },
  data() {
    return {
      searchString: '',
      data: {},
      reflexTunerHidden: true,
      crsfToken: '',
      searchURL: '/searchCognates',
      loading: false,
    }
  },
  components: {
    ReflexTuner,
  },
  mounted() {
    // this.searchURL = this.backendURL + this.searchURL;
  },
  methods: {
    search() {
      var data = {
        Akkadian: this.$refs.reflexTuner.Akkadian,
        Aramaic: this.$refs.reflexTuner.Aramaic,
      }
      data['searchString'] = this.searchString
      this.csrfToken = document.cookie.split(';').find(cookie => cookie.trim().startsWith('csrftoken='))?.split('=')[1];

      this.$apiClient.post(this.searchURL, data)
        .then(response => (
          this.data = response.data,
          this.loading = false)
        )
      this.loading = true;
    },
    onEnter() {
      if (this.$refs.searchInput.value != this.searchString) {
        this.searchString = this.$refs.searchInput.value;
      }
      this.search();
    },
    onCharButtonClicked() {
      if (event) {
        const start = this.$refs.searchInput.selectionStart;
        const end = this.$refs.searchInput.selectionStart;
        const currentValue = this.$refs.searchInput.value;
        const newValue = currentValue.substring(0, start) + event.target.textContent + currentValue.substring(end);
        this.$refs.searchInput.value = newValue;
        // this.searchString = newValue;
        const newCursorPosition = start + 1;
        this.$refs.searchInput.setSelectionRange(newCursorPosition, newCursorPosition);
        this.$refs.searchInput.focus();
      }
    },
    onReflexTunerToggleChange() {
      this.reflexTunerHidden = !event.target.checked;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
small {
  font-size: 0.5em;
}
</style>
